<template>
  <div>
    <div class="wwi-step-form">
      <wwi-page-header
        :step="2"
        :title="$t('pages.userdata.title')"
        :description="$t('pages.userdata.description')"
        :error="hasFormErrors ? $t('pages.userdata.error') : ''"
      />
      <form
        @submit.prevent="submit()"
        @keyup.enter="submit()"
      >
        <select
          v-model="userdata.salutation"
          :class="{ 'wwi-form--error': formError('salutation') }"
        >
          <option
            disabled
            value=""
          >
            {{ $t('pages.userdata.salutation') }}
          </option>
          <option
            v-for="(salutation, value) in $t('pages.userdata.salutations')"
            :key="value"
            :value="value"
          >
            {{ salutation }}
          </option>
        </select>
        <float-label>
          <input
            v-model="userdata.firstname"
            type="text"
            :placeholder="$t('pages.userdata.firstname')"
            :class="{ 'wwi-form--error': formError('firstname') }"
          >
        </float-label>
        <float-label>
          <input
            v-model="userdata.lastname"
            type="text"
            :placeholder="$t('pages.userdata.lastname')"
            :class="{ 'wwi-form--error': formError('lastname') }"
          >
        </float-label>
        <float-label>
          <input
            v-model="userdata.street"
            type="text"
            :placeholder="$t('pages.userdata.street')"
            :class="{ 'wwi-form--error': formError('street') }"
          >
        </float-label>
        <div class="wwi-form-zip-city-wrapper">
          <float-label>
            <input
              v-model="userdata.zip_code"
              type="text"
              :placeholder="$t('pages.userdata.zip_code')"
              :class="{ 'wwi-form--error': formError('zip_code') }"
            >
          </float-label>
          <float-label>
            <input
              v-model="userdata.city"
              type="text"
              :placeholder="$t('pages.userdata.city')"
              :class="{ 'wwi-form--error': formError('city') }"
            >
          </float-label>
        </div>
        <select
          v-model="userdata.country_id"
          :class="{ 'wwi-form--error': formError('country_id') }"
        >
          <option
            v-for="country in countries"
            :key="country.id"
            :value="country.id"
          >
            {{ country.name }}
          </option>
        </select>
        <float-label>
          <input
            v-model="userdata.phone"
            type="text"
            :placeholder="$t('pages.userdata.phone')"
            :class="{ 'wwi-form--error': formError('phone') }"
          >
        </float-label>
        <i18n
          path="pages.userdata.agreement"
          tag="p"
        >
          <a
            place="gtc"
            :href="gtcUrl"
            target="_blank"
          >{{ $t('pages.userdata.gtc') }}</a>
          <a
            place="privacy"
            :href="privacyUrl"
            target="_blank"
          >{{ $t('pages.userdata.privacy') }}</a>
        </i18n>
      </form>
      <wwi-continue-back @continue="submit()" />
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      userdata: {
        salutation: '',
        firstname: '',
        lastname: '',
        street: '',
        zip_code: '',
        city: '',
        country_id: null,
        phone: '',
        gtc: true
      }
    }
  },
  computed: {
    countries () {
      return this.$store.getters['countries/countries']
    },
    contractor () {
      return this.$store.getters['general/contractor']
    },
    gtcUrl () {
      return 'https://www.hosttech.' + this.contractor + '/agb'
    },
    privacyUrl () {
      return 'https://www.hosttech.' + this.contractor + '/datenschutz'
    }
  },
  async mounted () {
    this.userdata = this.$store.getters['userdata/userdata']
    await this.$store.dispatch('countries/GetCountries')
    if (!this.userdata.country_id) {
      this.userdata.country_id = this.countries.filter(country => country.default)[0].id
    }
  },
  methods: {
    async submit () {
      await this.$store.dispatch('userdata/ValidateUserdata', this.userdata)

      if (!this.hasFormErrors) {
        this.$router.push('domain')
      }
    }
  }
}

</script>
